import { render, staticRenderFns } from "./SradioPreview.vue?vue&type=template&id=a2d12ae0&"
import script from "./SradioPreview.vue?vue&type=script&lang=js&"
export * from "./SradioPreview.vue?vue&type=script&lang=js&"
import style0 from "./SradioPreview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports